/**
 * Feed charting entry DTOs
 * Extracted from src/services/patientmr/charting.service.ts
 */

import { BaseEntryData } from './chart-entry.dto';

/**
 * Feed data structure for pediatric patients
 */
export interface FeedData extends BaseEntryData {
  /** Free text; older entries have only this */
  feedDetails?: string;
  feedType?: FeedType;
  formula?: string;
  volumeMl?: number;
  durationMinutes?: number;
  rateMlPerHour?: number;
  tolerance?: FeedTolerance;
  residualMl?: number;
  notes?: string;
}

export const FEED_TYPES = ['BOLUS', 'CONTINUOUS', 'ORAL', 'BREAST', 'BOTTLE'] as const;
export type FeedType = typeof FEED_TYPES[number];
export const FEED_TOLERANCES = ['TOLERATED', 'PARTIAL', 'NOT_TOLERATED', 'EMESIS', 'HELD'] as const;
export type FeedTolerance = typeof FEED_TOLERANCES[number];
